import React from 'react'

import Header from '../../components/Header/SuccessStories'

const SuccessStoryHeaderEnonic = (props: any) => {
    return <Header {...props} />
}

export default SuccessStoryHeaderEnonic